export interface BlogPostSummary {
  title: string;
  slug: string;
  canonicalUrl: string;
  excerpt: string;
  description: string;
  date: string;
  publishedAt: string;
  updatedAt: string;
  author: string;
  image: string;
  readingTime: string;
  categories: string[];
  textLength: number;
}

export const blogPosts: BlogPostSummary[] = [
  {
    "title": "Almanya’da Posta Kutusuna Gelen Mektupları Düzenleme Yöntemim",
    "slug": "/post/almanyada-mektuplari-duzenleme",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-mektuplari-duzenleme",
    "excerpt": "Resmî mektuplar, faturalar ve okul yazıları birikmeden nasıl ayrılır? Posta kutusundan dijital arşive uzanan basit düzenimi adım adım anlatıyorum.",
    "description": "Resmî mektuplar, faturalar ve okul yazıları birikmeden nasıl ayrılır? Posta kutusundan dijital arşive uzanan basit düzenimi adım adım anlatıyorum.",
    "date": "19 Eki 2026",
    "publishedAt": "2026-10-19T07:00:00.000Z",
    "updatedAt": "2026-10-19T07:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "/images/blog/drafts/mektuplar.jpg",
    "readingTime": "6 dakikada okunur",
    "categories": [],
    "textLength": 4154
  },
  {
    "title": "Almanya’da Toplu Taşıma Kullanırken İşe Yarayan Uygulamalar ve İpuçları",
    "slug": "/post/almanyada-toplu-tasima-uygulamalari",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-toplu-tasima-uygulamalari",
    "excerpt": "Tren, tramvay ve otobüs yolculuklarında güzergâh bulma, gecikmeleri takip etme ve doğru bileti seçme konusunda işime yarayan uygulamaları anlatıyorum.",
    "description": "Tren, tramvay ve otobüs yolculuklarında güzergâh bulma, gecikmeleri takip etme ve doğru bileti seçme konusunda işime yarayan uygulamaları anlatıyorum.",
    "date": "12 Eki 2026",
    "publishedAt": "2026-10-12T07:00:00.000Z",
    "updatedAt": "2026-10-12T07:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "/images/blog/drafts/toplu-tasima.jpg",
    "readingTime": "5 dakikada okunur",
    "categories": [],
    "textLength": 3598
  },
  {
    "title": "Kita Çantasında Neler Olmalı? Günlük Hazırlık Listesi",
    "slug": "/post/kita-cantasinda-neler-olmali",
    "canonicalUrl": "https://www.aysegulsarac.com/post/kita-cantasinda-neler-olmali",
    "excerpt": "Kita’daki dolapta sürekli kalanlarla her gün getirip götürdüğümüz suluk ve Brotdose’yi ayırarak sade bir hazırlık listesi paylaşıyorum.",
    "description": "Kita’daki dolapta sürekli kalanlarla her gün getirip götürdüğümüz suluk ve Brotdose’yi ayırarak sade bir hazırlık listesi paylaşıyorum.",
    "date": "05 Eki 2026",
    "publishedAt": "2026-10-05T07:00:00.000Z",
    "updatedAt": "2026-10-05T07:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "/images/blog/drafts/kita-cantasi.jpg",
    "readingTime": "5 dakikada okunur",
    "categories": [],
    "textLength": 3453
  },
  {
    "title": "Almanya’da Kita’ya Alışma Süreci: Eingewöhnung Döneminde Neler Yaşanır?",
    "slug": "/post/almanyada-kita-alisma-sureci-eingewohnung",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-kita-alisma-sureci-eingewohnung",
    "excerpt": "Kita’ya başlangıçta çocuk ve ebeveyni neler bekler? Eingewöhnung dönemini, ilk kısa ziyaretlerden vedalaşmaya kadar deneyime dayalı ve sade biçimde anlatıyorum.",
    "description": "Kita’ya başlangıçta çocuk ve ebeveyni neler bekler? Eingewöhnung dönemini, ilk kısa ziyaretlerden vedalaşmaya kadar deneyime dayalı ve sade biçimde anlatıyorum.",
    "date": "28 Eyl 2026",
    "publishedAt": "2026-09-28T07:00:00.000Z",
    "updatedAt": "2026-09-28T07:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "/images/blog/drafts/kita-eingewohnung.jpg",
    "readingTime": "8 dakikada okunur",
    "categories": [],
    "textLength": 5358
  },
  {
    "title": "Telc B1'e Nasıl Hazırlandım? Kaynaklarım ve Yöntemim",
    "slug": "/post/telc-b1-hazirlik-sureci",
    "canonicalUrl": "https://www.aysegulsarac.com/post/telc-b1-hazirlik-sureci",
    "excerpt": "Telc B1 sınavına 1,5 ayda kendi başıma nasıl hazırlandım, hangi kaynakları kullandım, günlük rutinim nasıldı? 219 puanla geçtiğim hazırlık sürecimin tüm detayları.",
    "description": "Telc B1 sınavına 1,5 ayda kendi başıma nasıl hazırlandım, hangi kaynakları kullandım, günlük rutinim nasıldı? 219 puanla geçtiğim hazırlık sürecimin tüm detayları.",
    "date": "10 Tem 2026",
    "publishedAt": "2026-07-10T08:00:00.000Z",
    "updatedAt": "2026-07-10T08:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "/images/blog/telc-b1-hazirlik-sureci.jpg",
    "readingTime": "10 dakikada okunur",
    "categories": [],
    "textLength": 8200
  },
  {
    "title": "Telc B1 Sınav Günü: Sınav Ortamı, Taktikler ve Deneyimim",
    "slug": "/post/telc-b1-sinav-gunu",
    "canonicalUrl": "https://www.aysegulsarac.com/post/telc-b1-sinav-gunu",
    "excerpt": "Telc B1 sınavına girdim ve 219 puanla geçtim. Bu yazıda sınav gününü baştan sona anlatıyorum — sınav merkezi nasıldı, Vorbereitung odasında neler oluyor, en zorlandığım an neydi ve hangi taktikleri kullandım.",
    "description": "Telc B1 sınavına girdim ve 219 puanla geçtim. Bu yazıda sınav gününü baştan sona anlatıyorum — sınav merkezi nasıldı, Vorbereitung odasında neler oluyor, en zorlandığım an neydi ve hangi taktikleri kullandım.",
    "date": "02 Tem 2026",
    "publishedAt": "2026-07-02T08:00:00.000Z",
    "updatedAt": "2026-07-02T08:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "/images/blog/telc-b1-sinav-gunu.jpg",
    "readingTime": "12 dakikada okunur",
    "categories": [],
    "textLength": 9500
  },
  {
    "title": "Almanya'da Kalıcı Oturum Başvurusu: A1 Almanca ve Einbürgerungstest",
    "slug": "/post/kalici-oturum-a1-einburgerungstest",
    "canonicalUrl": "https://www.aysegulsarac.com/post/kalici-oturum-a1-einburgerungstest",
    "excerpt": "Köln'de Mustafa'nın kalıcı oturum (Niederlassungserlaubnis) sürecinde A1 Almanca sınavı ve Einbürgerungstest Yabancılar Dairesi'nde yapıldı. Bu yöntemin avantajları, sertifika nüansı ve bilinmesi gerekenler.",
    "description": "Köln'de Mustafa'nın kalıcı oturum (Niederlassungserlaubnis) sürecinde A1 Almanca sınavı ve Einbürgerungstest Yabancılar Dairesi'nde yapıldı. Bu yöntemin avantajları, sertifika nüansı ve bilinmesi gerekenler.",
    "date": "11 Haz 2026",
    "publishedAt": "2026-06-11T08:00:00.000Z",
    "updatedAt": "2026-06-11T08:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "/images/blog/kalici-oturum-a1-einburgerungstest.jpg",
    "readingTime": "6 dakikada okunur",
    "categories": [],
    "textLength": 7500
  },
  {
    "title": "Almanya'da Hausarzt (Aile Hekimi) Nasıl Bulunur?",
    "slug": "/post/almanyada-hausarzt-bulma",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-hausarzt-bulma",
    "excerpt": "Almanya'da Hausarzt (aile hekimi) sistemi nasıl işliyor, biz Köln'de Hausarzt'ımızı nasıl bulduk, Doctolib gibi platformlardan online randevu nasıl alınır? Deneyimlerimizi paylaşıyoruz.",
    "description": "Almanya'da Hausarzt (aile hekimi) sistemi nasıl işliyor, biz Köln'de Hausarzt'ımızı nasıl bulduk, Doctolib gibi platformlardan online randevu nasıl alınır? Deneyimlerimizi paylaşıyoruz.",
    "date": "10 Haz 2026",
    "publishedAt": "2026-06-10T08:00:00.000Z",
    "updatedAt": "2026-06-10T08:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "/images/blog/almanyada-hausarzt-bulma.jpg",
    "readingTime": "6 dakikada okunur",
    "categories": [],
    "textLength": 6800
  },
  {
    "title": "Almanya’da İş Bulma Süreci: Bir Mühendisin Deneyimleri",
    "slug": "/post/almanyada-is-bulmak",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-is-bulmak",
    "excerpt": "Almanya’da iş bulma süreci, yeni bir hayata başlamak isteyen birçok kişi için göz korkutucu. Bu yazıda size Sogand’ın hikayesini aktaracağım. ",
    "description": "Almanya’da iş bulma süreci, yeni bir hayata başlamak isteyen birçok kişi için göz korkutucu. Bu yazıda size Sogand’ın hikayesini aktaracağım. ",
    "date": "2 May 2025",
    "publishedAt": "2025-05-02T05:14:03.488Z",
    "updatedAt": "2025-05-02T05:14:03.488Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/11062b_706fd57cae8f43918b321ccd617908e9~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/11062b_706fd57cae8f43918b321ccd617908e9~mv2.jpg",
    "readingTime": "4 dakikada okunur",
    "categories": [],
    "textLength": 5324
  },
  {
    "title": "Almanya’da Yaşam - Sabırlı Olmayı Öğrenmek",
    "slug": "/post/almanyada-yasam",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-yasam",
    "excerpt": "Bu yazımda, Almanya’da yaşamın bana sabırlı olmayı nasıl öğrettiğinden ve karşılaştığım zorlukları nasıl aşmaya çalıştığımdan bahsedeceğim. ",
    "description": "Bu yazımda, Almanya’da yaşamın bana sabırlı olmayı nasıl öğrettiğinden ve karşılaştığım zorlukları nasıl aşmaya çalıştığımdan bahsedeceğim. ",
    "date": "28 Nis 2025",
    "publishedAt": "2025-04-28T07:22:51.126Z",
    "updatedAt": "2025-04-28T07:30:06.679Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_35714d596a50625f2d5a67~mv2_d_4669_7000_s_4_2.jpg/v1/fill/w_667,h_1000,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_35714d596a50625f2d5a67~mv2_d_4669_7000_s_4_2.jpg",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 4983
  },
  {
    "title": "Almanya'da Şahıs Şirketi Kurmak",
    "slug": "/post/almanyada-sirket-kurmak",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-sirket-kurmak",
    "excerpt": "Almanya'da şirket kurma süreci, Gewerbeanmeldung (işletme kaydı) ile başlar. Yerel belediyenin web sitesinden başvuru yaparak işlemleri tamamlayabilirsiniz.",
    "description": "Almanya'da şirket kurma süreci, Gewerbeanmeldung (işletme kaydı) ile başlar. Yerel belediyenin web sitesinden başvuru yaparak işlemleri tamamlayabilirsiniz.",
    "date": "24 Şub 2025",
    "publishedAt": "2025-02-24T09:26:41.431Z",
    "updatedAt": "2025-02-24T10:59:17.048Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/18f46c_09ecabebdcb84bf7aaa4e3a7b0be7114~mv2.png/v1/fill/w_1000,h_1000,al_c,q_90,usm_0.66_1.00_0.01/18f46c_09ecabebdcb84bf7aaa4e3a7b0be7114~mv2.png",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 5308
  },
  {
    "title": "Almanya’da Kredi Çekmek",
    "slug": "/post/almanya-da-kredi-cekmek",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanya-da-kredi-cekmek",
    "excerpt": "Almanya’da Kredi Çekmek: Kredi Çekme Kriterleri Nelerdir?\nAlmanya’da kredi çekmek, Türkiye’ye kıyasla farklı bir süreç ve bazı özel kriterler içeriyor. Almanya’da kredi başvurusu yaparken sadece finansal durum değil, aynı zamanda oturma izninizin durumu, iş sözleşmeniz, gelir düzeyiniz ve hatta kredi geçmişiniz gibi faktörler de büyük rol oynuyor. ",
    "description": "Almanya’da Kredi Çekmek: Kredi Çekme Kriterleri Nelerdir?\nAlmanya’da kredi çekmek, Türkiye’ye kıyasla farklı bir süreç ve bazı özel kriterler içeriyor. Almanya’da kredi başvurusu yaparken sadece finansal durum değil, aynı zamanda oturma izninizin durumu, iş sözleşmeniz, gelir düzeyiniz ve hatta kredi geçmişiniz gibi faktörler de büyük rol oynuyor. ",
    "date": "13 Şub 2025",
    "publishedAt": "2025-02-13T09:09:53.494Z",
    "updatedAt": "2025-02-13T09:13:07.973Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/52f3042dfdef4e71af5f90bf69e9cb57.jpg/v1/fill/w_1000,h_666,al_c,q_85,usm_0.66_1.00_0.01/52f3042dfdef4e71af5f90bf69e9cb57.jpg",
    "readingTime": "4 dakikada okunur",
    "categories": [],
    "textLength": 5439
  },
  {
    "title": "Almanya’da Yaşam: Güven Sistemi ve Deneyimler",
    "slug": "/post/almanyada-yasam-guven",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-yasam-guven",
    "excerpt": "Almanya’da Yaşam: Güven Sistemi ve Deneyimler.\nAlmanya’daki yaşamda güven duygusu oldukça güçlü. Burada, özellikle devlete ve insanlara güven konusunda büyük farklar olduğunu gözlemliyorum.",
    "description": "Almanya’da Yaşam: Güven Sistemi ve Deneyimler.\nAlmanya’daki yaşamda güven duygusu oldukça güçlü. Burada, özellikle devlete ve insanlara güven konusunda büyük farklar olduğunu gözlemliyorum.",
    "date": "16 Oca 2025",
    "publishedAt": "2025-01-16T08:01:36.649Z",
    "updatedAt": "2025-01-23T08:31:31.952Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_746e3272426e76496c3949~mv2_d_4496_3000_s_4_2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_746e3272426e76496c3949~mv2_d_4496_3000_s_4_2.jpg",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 4079
  },
  {
    "title": "Köln mü Münih mi? – Almanya'ya Göç ve Almanya’da Yaşam",
    "slug": "/post/koln-munih",
    "canonicalUrl": "https://www.aysegulsarac.com/post/koln-munih",
    "excerpt": "Almanya'ya yerleşmeyi düşünenler veya burada yaşamayı planlayanlar, genellikle hangi şehirde yaşamaya karar vereceklerini çok merak ediyorlar. Köln mü, Münih mi?",
    "description": "Almanya'ya yerleşmeyi düşünenler veya burada yaşamayı planlayanlar, genellikle hangi şehirde yaşamaya karar vereceklerini çok merak ediyorlar. Köln mü, Münih mi?",
    "date": "13 Oca 2025",
    "publishedAt": "2025-01-13T08:47:26.063Z",
    "updatedAt": "2025-01-31T09:11:10.192Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_e662a279cfd2476fbfb553048024da33~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_e662a279cfd2476fbfb553048024da33~mv2.jpg",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 4131
  },
  {
    "title": "Zusatzblatt Nedir? A, B, C, D Formları ve Erklärung zum Beschäftigungsverhältnis (EZB) Açıklaması",
    "slug": "/post/almanya_ezb_formu",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanya_ezb_formu",
    "excerpt": "Zusatzblatt nedir, hangi başvuruda istenir? Zusatzblatt A, B, C, D formları nasıl farklı? EZB (Erklärung zum Beschäftigungsverhältnis) ne anlama gelir, kim doldurur, nereye verilir? Bizim Almanya'da çalışma ve oturum izinleri sürecinde karşılaştığımız form türlerini, hangi başvurularda istendiğini ve kendi deneyimimizden öğrendiklerimizi paylaşıyoruz.",
    "description": "Zusatzblatt nedir, A/B/C/D formları arasındaki fark nedir? EZB (Erklärung zum Beschäftigungsverhältnis) ne demek, kim doldurur? Bizim deneyimimizden Zusatzblatt formlarının hangi başvurularda istendiği ve nasıl temin edildiği.",
    "date": "6 Oca 2025",
    "publishedAt": "2025-01-06T10:56:14.916Z",
    "updatedAt": "2026-06-09T00:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/11062b_e56b9bcf950a46bd8ad13486e39ac3b7~mv2.jpeg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/11062b_e56b9bcf950a46bd8ad13486e39ac3b7~mv2.jpeg",
    "readingTime": "4 dakikada okunur",
    "categories": [],
    "textLength": 4500
  },
  {
    "title": "Göçün Ardından Hayatımızda Neler Değişti? Almanya'ya Göç",
    "slug": "/post/almanyaya_goc",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyaya_goc",
    "excerpt": " Göç etmek hayatımızda neleri değiştirdi? Göç öncesindeki bizle şimdiki biz arasındaki farklar neler? Bu süreçte neleri sevdik, nelere alıştık? Belki bu yazı, Almanya'ya taşınmayı düşünenler için bir rehber olur ve bazı sorularınıza yanıt bulabilirsiniz.",
    "description": " Göç etmek hayatımızda neleri değiştirdi? Göç öncesindeki bizle şimdiki biz arasındaki farklar neler? Bu süreçte neleri sevdik, nelere alıştık? Belki bu yazı, Almanya'ya taşınmayı düşünenler için bir rehber olur ve bazı sorularınıza yanıt bulabilirsiniz.",
    "date": "20 Ara 2024",
    "publishedAt": "2024-12-20T14:15:10.553Z",
    "updatedAt": "2025-01-23T08:30:47.455Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/11062b_4b08c563cbf5450590a4c026b86df96b~mv2.jpeg/v1/fill/w_1000,h_588,al_c,q_85,usm_0.66_1.00_0.01/11062b_4b08c563cbf5450590a4c026b86df96b~mv2.jpeg",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 3904
  },
  {
    "title": "Avrupa Birliği Vatandaşı Eşiyle Birlikte Almanya’da Yeni Bir Başlangıç - AB vatandaşlarının Almanya'ya Göçü",
    "slug": "/post/ab-vatandaslarinin-almanyaya-gocu",
    "canonicalUrl": "https://www.aysegulsarac.com/post/ab-vatandaslarinin-almanyaya-gocu",
    "excerpt": "Almanya'ya göç ve aile birleşimi sürecini anlatan Özlem'in deneyimlerinden, oturma izni başvurusu ve önemli ipuçlarına kadar her şeyi keşfedin.",
    "description": "Almanya'ya göç ve aile birleşimi sürecini anlatan Özlem'in deneyimlerinden, oturma izni başvurusu ve önemli ipuçlarına kadar her şeyi keşfedin.",
    "date": "11 Ara 2024",
    "publishedAt": "2024-12-11T12:25:33.819Z",
    "updatedAt": "2025-01-23T08:30:32.816Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_674d4a3374464f4c766e41~mv2_d_4500_2610_s_4_2.jpg/v1/fill/w_1000,h_580,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_674d4a3374464f4c766e41~mv2_d_4500_2610_s_4_2.jpg",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 4693
  },
  {
    "title": "Almanya’ya Nasıl Göç Ederim?",
    "slug": "/post/almanyaya-nasil-goc-ederim",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyaya-nasil-goc-ederim",
    "excerpt": "Merhaba! Almanya’ya göç etmeyi düşünüyorsanız, bu süreçte dikkat etmeniz gereken pek çok önemli adım ve seçenek bulunuyor. Almanya, güçlü ekonomisi, yüksek yaşam kalitesi ve sunduğu fırsatlarla birçok kişi için cazip bir destinasyon.",
    "description": "Merhaba! Almanya’ya göç etmeyi düşünüyorsanız, bu süreçte dikkat etmeniz gereken pek çok önemli adım ve seçenek bulunuyor. Almanya, güçlü ekonomisi, yüksek yaşam kalitesi ve sunduğu fırsatlarla birçok kişi için cazip bir destinasyon.",
    "date": "22 Kas 2024",
    "publishedAt": "2024-11-22T10:54:41.510Z",
    "updatedAt": "2025-01-23T08:30:14.832Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_7745613531315278704263~mv2.jpg/v1/fill/w_1000,h_663,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_7745613531315278704263~mv2.jpg",
    "readingTime": "4 dakikada okunur",
    "categories": [],
    "textLength": 5761
  },
  {
    "title": "YouTube'da 10.000 Aboneye Ulaşmanın Heyecanı ve Sonsuz Teşekkürler 💚",
    "slug": "/post/youtube-10000",
    "canonicalUrl": "https://www.aysegulsarac.com/post/youtube-10000",
    "excerpt": "10.000 aboneye ulaşmanın gururunu yaşıyorum! YouTube kanalımda emeği geçen herkese sonsuz teşekkürler. Desteklerinizle daha nice hedeflere ulaşacağız.",
    "description": "10.000 aboneye ulaşmanın gururunu yaşıyorum! YouTube kanalımda emeği geçen herkese sonsuz teşekkürler. Desteklerinizle daha nice hedeflere ulaşacağız.",
    "date": "15 Kas 2024",
    "publishedAt": "2024-11-15T13:37:58.113Z",
    "updatedAt": "2025-01-23T08:29:53.986Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_b2b9238fc4814b3d93b5c6d88c58ac22~mv2.png/v1/fill/w_1000,h_563,al_c,q_90,usm_0.66_1.00_0.01/7d6a1f_b2b9238fc4814b3d93b5c6d88c58ac22~mv2.png",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 3801
  },
  {
    "title": "Almanya’da Kariyer Değiştirme Yolculuğu: Weiterbildung ile UX Designer Olmak ve Arbeitsagentur’dan Eğitim Desteği Almak",
    "slug": "/post/almanyada-kariyer-degisimi",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-kariyer-degisimi",
    "excerpt": "Almanya’da kariyer değişikliği yaparak UX Designer olmak isteyenlere yönelik Weiterbildung ve Arbeitsagentur eğitim desteği deneyimi.",
    "description": "Almanya’da kariyer değişikliği yaparak UX Designer olmak isteyenlere yönelik Weiterbildung ve Arbeitsagentur eğitim desteği deneyimi.",
    "date": "7 Kas 2024",
    "publishedAt": "2024-11-07T10:25:12.553Z",
    "updatedAt": "2025-01-23T08:29:27.742Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_5ae879cdb55f49afa930ee4c70b2e581~mv2.jpg/v1/fill/w_1000,h_563,al_c,q_85,usm_0.66_1.00_0.01/7d6a1f_5ae879cdb55f49afa930ee4c70b2e581~mv2.jpg",
    "readingTime": "8 dakikada okunur",
    "categories": [],
    "textLength": 12187
  },
  {
    "title": "Almanya’da Anmeldung Nedir ve Nasıl Yapılır?",
    "slug": "/post/almanyada-anmeldung-nedir-ve-nasil-yapilir",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-anmeldung-nedir-ve-nasil-yapilir",
    "excerpt": "Anmeldung, Almanya’da ikamet adresinizi resmi olarak kaydettirme sürecidir. Bu işlemi taşındıktan sonra 14 gün içinde tamamlamanız gerekmektedir. Aksi halde, cezai yaptırımlar uygulanabilir. ",
    "description": "Anmeldung, Almanya’da ikamet adresinizi resmi olarak kaydettirme sürecidir. Bu işlemi taşındıktan sonra 14 gün içinde tamamlamanız gerekmektedir. Aksi halde, cezai yaptırımlar uygulanabilir. ",
    "date": "2 Eki 2024",
    "publishedAt": "2024-10-02T15:30:13.233Z",
    "updatedAt": "2025-01-23T08:28:44.817Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/5cf44d588bd0471aa3e31664a3d751f5.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/5cf44d588bd0471aa3e31664a3d751f5.jpg",
    "readingTime": "2 dakikada okunur",
    "categories": [],
    "textLength": 2924
  },
  {
    "title": "Almanya’ya Göç Etmenin Yolları",
    "slug": "/post/almanyaya-goc-etmenin-yollari",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyaya-goc-etmenin-yollari",
    "excerpt": "Almanya’ya göç etmenin çeşitli yolları vardır ve bu yazıda bunlardan dört ana yolunu detaylandıracağım. İş Bularak Almanya’ya Göç Etmek, İş Arama Vizesiyle Almanya’ya Gitmek, Eğitim İçin Almanya’ya Göç Etmek, Aile Birleşimi Yoluyla Almanya’ya Göç Etmek. Hangi seçeneğin sizin için en uygun olduğuna karar vermenize yardımcı olmak için bu yollardan detaylı olarak aşağıda bahsedeceğim.",
    "description": "Almanya’ya göç etmenin çeşitli yolları vardır ve bu yazıda bunlardan dört ana yolunu detaylandıracağım. İş Bularak Almanya’ya Göç Etmek, İş Arama Vizesiyle Almanya’ya Gitmek, Eğitim İçin Almanya’ya Göç Etmek, Aile Birleşimi Yoluyla Almanya’ya Göç Etmek. Hangi seçeneğin sizin için en uygun olduğuna karar vermenize yardımcı olmak için bu yollardan detaylı olarak aşağıda bahsedeceğim.",
    "date": "25 Eyl 2024",
    "publishedAt": "2024-09-25T15:30:13.761Z",
    "updatedAt": "2025-01-23T08:28:58.307Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/11062b_2a70042d56cd4db1a2729944834ef6fa~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/11062b_2a70042d56cd4db1a2729944834ef6fa~mv2.jpg",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 4705
  },
  {
    "title": "Almanya’da Devlet Destekli Dil Kursları",
    "slug": "/post/almanyada-devlet-destekli-dil-kurslari",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-devlet-destekli-dil-kurslari",
    "excerpt": "Türkiye'den Almanya'ya göç edenler için entegrasyon kursları, yeni bir hayata adapte olma sürecinde önemli bir rol oynar. Bu kurslar, dil becerilerini geliştirmek ve Alman kültürünü anlamak amacıyla düzenlenir. Almanya'da entegrasyon kursu almak zorunlu değildir, ancak devlet, bu kursların yarısını finanse eder. Böylece, katılımcılar daha uygun maliyetle eğitim alabilirler. Entegrasyon sürecine dair tüm bilgilere erişim sağlayarak, Almanya'da yaşamınıza kolay bir başlangıç yapın!",
    "description": "Türkiye'den Almanya'ya göç edenler için entegrasyon kursları, yeni bir hayata adapte olma sürecinde önemli bir rol oynar. Bu kurslar, dil becerilerini geliştirmek ve Alman kültürünü anlamak amacıyla düzenlenir. Almanya'da entegrasyon kursu almak zorunlu değildir, ancak devlet, bu kursların yarısını finanse eder. Böylece, katılımcılar daha uygun maliyetle eğitim alabilirler. Entegrasyon sürecine dair tüm bilgilere erişim sağlayarak, Almanya'da yaşamınıza kolay bir başlangıç yapın!",
    "date": "17 Eyl 2024",
    "publishedAt": "2024-09-17T22:00:00.000Z",
    "updatedAt": "2025-01-23T08:27:50.034Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_4a76733961744431713067~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_4a76733961744431713067~mv2.jpg",
    "readingTime": "2 dakikada okunur",
    "categories": [],
    "textLength": 3253
  },
  {
    "title": "Göç Ettikten Sonra Değişen Alışkanlıklar",
    "slug": "/post/goc-ettikten-sonra-degisen-aliskanliklar",
    "canonicalUrl": "https://www.aysegulsarac.com/post/goc-ettikten-sonra-degisen-aliskanliklar",
    "excerpt": "Almanya'ya göç ettikten sonra yeni bir kültüre uyum sağlama sürecimi ve bu süreçte yaşadığım duygusal zorlukları keşfedin. Almanya'ya göçün getirdiği değişimlerle başa çıkma ve yeni bir hayata adapte olma üzerine samimi bir anlatım.",
    "description": "Almanya'ya göç ettikten sonra yeni bir kültüre uyum sağlama sürecimi ve bu süreçte yaşadığım duygusal zorlukları keşfedin. Almanya'ya göçün getirdiği değişimlerle başa çıkma ve yeni bir hayata adapte olma üzerine samimi bir anlatım.",
    "date": "12 Eyl 2024",
    "publishedAt": "2024-09-12T12:17:19.553Z",
    "updatedAt": "2025-01-23T08:27:19.813Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/11062b_fbf8e926402f464cbdf8994ba9d42732~mv2.jpg/v1/fill/w_1000,h_560,al_c,q_85,usm_0.66_1.00_0.01/11062b_fbf8e926402f464cbdf8994ba9d42732~mv2.jpg",
    "readingTime": "2 dakikada okunur",
    "categories": [],
    "textLength": 2445
  },
  {
    "title": "Almanya’da Ehliyet: Türk Ehliyeti Geçerlilik, Sınav, Fiyat ve Süre Rehberi",
    "slug": "/post/almanyada-ehliyet-sureci",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-ehliyet-sureci",
    "excerpt": "Türk ehliyeti Almanya’da kaç ay geçerli? Almanya’da ehliyet almak ne kadar sürer ve kaç euroya mal olur? Sınav Türkçe mi yapılıyor? Göz muayenesi, ilk yardım kursu, ADAC çevirisi, TÜV yazılı ve direksiyon sınavı — tüm süreç, gerçek maliyetler ve kendi deneyimimden zaman çizelgesi.",
    "description": "Türk ehliyeti Almanya’da kaç ay geçerli? Ehliyet almak ne kadar sürer, kaç euro? Sınav Türkçe mi? Göz muayenesi, ilk yardım, ADAC çevirisi ve TÜV sınav süreci — kişisel deneyimden gerçek maliyetlerle rehber.",
    "date": "29 Ağu 2024",
    "publishedAt": "2024-08-29T09:25:26.953Z",
    "updatedAt": "2026-06-09T00:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_aba622d26be245c8bdf95bbf23385364~mv2.png/v1/fill/w_1000,h_750,al_c,q_90,usm_0.66_1.00_0.01/7d6a1f_aba622d26be245c8bdf95bbf23385364~mv2.png",
    "readingTime": "4 dakikada okunur",
    "categories": [],
    "textLength": 5100
  },
  {
    "title": "Almanya'da 1. Sınıfların Geleneği: Schultüte Nedir, Nasıl Hazırlanır?",
    "slug": "/post/almanyada-schultüte",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-schultüte",
    "excerpt": "Almanya'da okulun ilk günü, çocuklar ve aileler için büyük bir heyecan kaynağıdır. Bu özel günde, çocuklar genellikle el yapımı “Schultüte” (okul çantası) ile okula başlarlar; bu çanta, hediyelerle dolu olup yeni eğitim yılına sıcak bir başlangıç sağlar. Ayrıca, aileler ve arkadaşlar bir araya gelerek bu önemli anı kutlar. Okulun ilk günü gelenekleri, çocukların yeni ortamlarına uyum sağlamalarına yardımcı olur. Almanya'daki bu eşsiz deneyimi ve gelenekleri keşfedin!",
    "description": "Almanya'da okulun ilk günü, çocuklar ve aileler için büyük bir heyecan kaynağıdır. Bu özel günde, çocuklar genellikle el yapımı “Schultüte” (okul çantası) ile okula başlarlar; bu çanta, hediyelerle dolu olup yeni eğitim yılına sıcak bir başlangıç sağlar. Ayrıca, aileler ve arkadaşlar bir araya gelerek bu önemli anı kutlar. Okulun ilk günü gelenekleri, çocukların yeni ortamlarına uyum sağlamalarına yardımcı olur. Almanya'daki bu eşsiz deneyimi ve gelenekleri keşfedin!",
    "date": "24 Ağu 2024",
    "publishedAt": "2024-08-24T11:43:17.047Z",
    "updatedAt": "2025-01-23T08:26:41.703Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/11062b_119dc263a41f48bc9f7771780a9a47df~mv2_d_4752_3168_s_4_2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/11062b_119dc263a41f48bc9f7771780a9a47df~mv2_d_4752_3168_s_4_2.jpg",
    "readingTime": "2 dakikada okunur",
    "categories": [],
    "textLength": 3030
  },
  {
    "title": "Almanya'ya Çocuk ile Göç Etmek",
    "slug": "/post/almanyaya-cocuk-ile-goc",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyaya-cocuk-ile-goc",
    "excerpt": "Almanya'ya bebek veya çocukla göç etmek, aileler için birçok zorluğu ve önemli adımları beraberinde getirir. Bu rehberde, göç sürecinde dikkat edilmesi gerekenler, gerekli belgeler, sağlık hizmetlerine erişim, eğitim olanakları ve ikamet kaydı gibi konuları keşfedin. Aile birleşimi ve çocukların entegrasyonu sürecinde karşılaşabileceğiniz tüm zorluklara dair pratik bilgilerle, Almanya'da yeni bir başlangıç yapmanın yollarını öğrenin. Ailenizle birlikte yeni bir hayata adım atın!",
    "description": "Almanya'ya bebek veya çocukla göç etmek, aileler için birçok zorluğu ve önemli adımları beraberinde getirir. Bu rehberde, göç sürecinde dikkat edilmesi gerekenler, gerekli belgeler, sağlık hizmetlerine erişim, eğitim olanakları ve ikamet kaydı gibi konuları keşfedin. Aile birleşimi ve çocukların entegrasyonu sürecinde karşılaşabileceğiniz tüm zorluklara dair pratik bilgilerle, Almanya'da yeni bir başlangıç yapmanın yollarını öğrenin. Ailenizle birlikte yeni bir hayata adım atın!",
    "date": "29 Tem 2024",
    "publishedAt": "2024-07-29T11:23:25.935Z",
    "updatedAt": "2025-01-23T08:26:24.676Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_3663424b4d7854596d5777~mv2_d_5184_3456_s_4_2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_3663424b4d7854596d5777~mv2_d_5184_3456_s_4_2.jpg",
    "readingTime": "2 dakikada okunur",
    "categories": [],
    "textLength": 3264
  },
  {
    "title": "Almanya'da Okul Kayıt Süreci",
    "slug": "/post/almanyada-okula-kayit-sureci",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-okula-kayit-sureci",
    "excerpt": "Almanya’da çocukların ilkokula kaydı, ebeveynler için karmaşık ve uzun bir süreç olabilir. Bu rehberde, kayıt için gerekli belgeler, başvuru tarihleri ve dikkat edilmesi gereken önemli noktalar hakkında bilgi edinin. Almanya'nın eyaletlerindeki farklı kayıt prosedürlerini anlamak, çocuğunuzun doğru okula yerleşmesini sağlamak açısından kritik öneme sahiptir. İlkokul kayıt sürecini kolaylaştıracak ipuçlarıyla, çocuğunuzun eğitim hayatına en iyi başlangıcı yapın!",
    "description": "Almanya’da çocukların ilkokula kaydı, ebeveynler için karmaşık ve uzun bir süreç olabilir. Bu rehberde, kayıt için gerekli belgeler, başvuru tarihleri ve dikkat edilmesi gereken önemli noktalar hakkında bilgi edinin. Almanya'nın eyaletlerindeki farklı kayıt prosedürlerini anlamak, çocuğunuzun doğru okula yerleşmesini sağlamak açısından kritik öneme sahiptir. İlkokul kayıt sürecini kolaylaştıracak ipuçlarıyla, çocuğunuzun eğitim hayatına en iyi başlangıcı yapın!",
    "date": "5 Haz 2024",
    "publishedAt": "2024-06-05T22:00:00.000Z",
    "updatedAt": "2025-01-23T08:26:05.800Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/11062b_4f19822df8a749c3b5f9731dd1421136~mv2.jpg/v1/fill/w_1000,h_700,al_c,q_85,usm_0.66_1.00_0.01/11062b_4f19822df8a749c3b5f9731dd1421136~mv2.jpg",
    "readingTime": "5 dakikada okunur",
    "categories": [],
    "textLength": 7090
  },
  {
    "title": "Blue Card Süreci İle İlgili Merak Edilen Sorulardan Bazıları. ☀️",
    "slug": "/post/blue-card-bilgi",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanya-blue-card-vize",
    "excerpt": "Almanya Blue Card (Mavi Kart) vizesiyle ilgili merak edilen soruların cevaplarını öğrenmek ister misiniz? Bu kapsamlı rehberde, randevu alım süreci, aile birleşiminde dikkat edilmesi gerekenler, gerekli evraklar ve form doldurma adımları gibi önemli konulara dair detayları keşfedin. Mavi Kart vizesi başvurunuzu kolaylaştıracak tüm bilgileri bir arada bulacağınız bu yazıyla, Almanya'da yeni bir hayata başlama yolunda adımlarınızı güvenle atın!",
    "description": "Almanya Blue Card (Mavi Kart) vizesiyle ilgili merak edilen soruların cevaplarını öğrenmek ister misiniz? Bu kapsamlı rehberde, randevu alım süreci, aile birleşiminde dikkat edilmesi gerekenler, gerekli evraklar ve form doldurma adımları gibi önemli konulara dair detayları keşfedin. Mavi Kart vizesi başvurunuzu kolaylaştıracak tüm bilgileri bir arada bulacağınız bu yazıyla, Almanya'da yeni bir hayata başlama yolunda adımlarınızı güvenle atın!",
    "date": "2 May 2024",
    "publishedAt": "2024-05-02T11:35:05.000Z",
    "updatedAt": "2025-01-23T08:25:44.632Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_de9be89103d3444bbf6069d87b872815~mv2.jpg/v1/fill/w_1000,h_849,al_c,q_85,usm_0.66_1.00_0.01/7d6a1f_de9be89103d3444bbf6069d87b872815~mv2.jpg",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 4449
  },
  {
    "title": "Mavi Kart (Blue Card) Nasıl Alınır? Başvuru Şartları, Vize Süreci ve Gerekli Belgeler Rehberi",
    "slug": "/post/almanya-blue-card-vize",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanya-blue-card-vize",
    "excerpt": "Almanya Mavi Kart (Blue Card) nasıl alınır? Başvuru şartları, maaş eşiği, gerekli belgeler, vize randevusu ve değerlendirme süreci nasıl işliyor? Bizim 2020'de Köln'e Mavi Kart ile taşınma deneyimimizden başvuru hazırlığı, evrak süreci ve karşılaştığımız aşamalara dair pratik bilgiler.",
    "description": "Almanya Mavi Kart (Blue Card) nasıl alınır? Başvuru şartları, maaş eşiği, gerekli belgeler ve vize süreci. Bizim 2020'de Mavi Kart ile Köln'e taşınma deneyimimizden pratik bilgiler.",
    "date": "1 Nis 2024",
    "publishedAt": "2024-04-01T08:57:02.000Z",
    "updatedAt": "2026-06-09T00:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_6874517a6e532d52783777~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_6874517a6e532d52783777~mv2.jpg",
    "readingTime": "10 dakikada okunur",
    "categories": [],
    "textLength": 14123
  },
  {
    "title": "Almanya’ya Gelenler İçin Pratik Bilgiler ",
    "slug": "/post/almanyada-pratik-bilgiler",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-pratik-bilgiler",
    "excerpt": "Almanya'ya yeni taşındınız ve yaşamınızı kolaylaştıracak pratik bilgilere mi ihtiyacınız var? Bu yazıda, banka hesabı olmadan alışveriş yapmanın yolları, çöp atma sistemleri, posta hizmetleri ve döner sistemlerle ilgili bilmeniz gereken temel bilgileri keşfedin. Almanya’da yaşamınıza uyum sağlamanız için gerekli ipuçları ve pratik tavsiyelerle hayatınızı daha konforlu hale getirin. Hızlı ve etkili alışveriş yapmanın yollarını öğrenin!",
    "description": "Almanya'ya yeni taşındınız ve yaşamınızı kolaylaştıracak pratik bilgilere mi ihtiyacınız var? Bu yazıda, banka hesabı olmadan alışveriş yapmanın yolları, çöp atma sistemleri, posta hizmetleri ve döner sistemlerle ilgili bilmeniz gereken temel bilgileri keşfedin. Almanya’da yaşamınıza uyum sağlamanız için gerekli ipuçları ve pratik tavsiyelerle hayatınızı daha konforlu hale getirin. Hızlı ve etkili alışveriş yapmanın yollarını öğrenin!",
    "date": "1 Mar 2024",
    "publishedAt": "2024-03-01T14:40:00.000Z",
    "updatedAt": "2025-01-23T08:23:46.236Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_e07559bdef314fc7b87938fbfaff245d~mv2.png/v1/fill/w_1000,h_563,al_c,q_90,usm_0.66_1.00_0.01/7d6a1f_e07559bdef314fc7b87938fbfaff245d~mv2.png",
    "readingTime": "2 dakikada okunur",
    "categories": [],
    "textLength": 2935
  },
  {
    "title": "Almanya’da Kita, Kindergarten ve Tagesmutter: Farkları ve Başvuru Süreci",
    "slug": "/post/almanyada-kita-nasil-bulunur",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyada-kita-nasil-bulunur",
    "excerpt": "Almanya’da Kita, Kindergarten ve Tagesmutter arasındaki farkları, yaş gruplarını ve başvuru sürecinde dikkat edilmesi gerekenleri kendi tecrübelerimiz ışığında anlatıyorum.",
    "description": "Almanya’da Kita, Kindergarten ve Tagesmutter arasındaki farkları, yaş gruplarını ve başvuru sürecinde dikkat edilmesi gerekenleri öğrenin.",
    "date": "21 Eyl 2026",
    "publishedAt": "2026-09-21T00:00:00.000Z",
    "updatedAt": "2026-09-21T00:00:00.000Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_947710fb3b7d498889fd0bcfdd7021a2~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_947710fb3b7d498889fd0bcfdd7021a2~mv2.jpg",
    "readingTime": "10 dakikada okunur",
    "categories": [],
    "textLength": 11200
  },
  {
    "title": "Almanya'ya Geldik Şimdi Ne Olacak? Almanya'ya Gelince Yapılması Gerekenler",
    "slug": "/post/almanyaya-geldik-simdi-ne-olacak",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyaya-geldik-simdi-ne-olacak",
    "excerpt": "Almanya'ya yeni geldiyseniz, doğru adımları atmak hayatınızı kolaylaştıracaktır. Bu rehberde, Almanya'da yaşamak için mutlaka yapmanız gereken işlemleri keşfedin. Anmeldung (ikamet kaydı), banka hesabı açma, sağlık sigortası edinme ve telefon hattı almanın önemini öğrenin. Almanya'da yaşamınızı sorunsuz hale getirmek için bilmeniz gereken tüm detaylar burada!",
    "description": "Almanya'ya yeni geldiyseniz, doğru adımları atmak hayatınızı kolaylaştıracaktır. Bu rehberde, Almanya'da yaşamak için mutlaka yapmanız gereken işlemleri keşfedin. Anmeldung (ikamet kaydı), banka hesabı açma, sağlık sigortası edinme ve telefon hattı almanın önemini öğrenin. Almanya'da yaşamınızı sorunsuz hale getirmek için bilmeniz gereken tüm detaylar burada!",
    "date": "4 Oca 2024",
    "publishedAt": "2024-01-04T09:43:24.000Z",
    "updatedAt": "2025-01-23T08:21:23.361Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_3143724e2d496276744830~mv2_d_3500_2333_s_2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_3143724e2d496276744830~mv2_d_3500_2333_s_2.jpg",
    "readingTime": "6 dakikada okunur",
    "categories": [],
    "textLength": 9651
  },
  {
    "title": "Değişin, ve Bundan Korkmayın. 🦋",
    "slug": "/post/degisin-ve-bundan-korkmayin",
    "canonicalUrl": "https://www.aysegulsarac.com/post/degisin-ve-bundan-korkmayin",
    "excerpt": "Kendinizi, alışkanlıklarınızı değiştirmekten korkmayın. Sizi yansıtan bir ayna bulun ve kendinize uzaktan bir bakın.  İnsan çabuk unutuyor yaşadıklarını, ya da çabuk unutan bir kesim var ve ben çabuk unutan kesimin içerisindeyim. Bu 1 yıldır o kadar farklı ki her şey. 1 yıl önce neye, nasıl tepki verirdim inanın tahmin edemiyorum. O kadar farklı biri haline dönüştüm ki, asıl Ayşegül’le şimdi tanışıyorum. Kendimi dinliyor, uzun uzun düşünüyor, hiçbir şey için acele etmiyorum.  Sanırım ben biraz d",
    "description": "Kendinizi, alışkanlıklarınızı değiştirmekten korkmayın. Sizi yansıtan bir ayna bulun ve kendinize uzaktan bir bakın.  İnsan çabuk unutuyor yaşadıklarını, ya da çabuk unutan bir kesim var ve ben çabuk unutan kesimin içerisindeyim. Bu 1 yıldır o kadar farklı ki her şey. 1 yıl önce neye, nasıl tepki verirdim inanın tahmin edemiyorum. O kadar farklı biri haline dönüştüm ki, asıl Ayşegül’le şimdi tanışıyorum. Kendimi dinliyor, uzun uzun düşünüyor, hiçbir şey için acele etmiyorum.  Sanırım ben biraz d",
    "date": "18 Eki 2021",
    "publishedAt": "2021-10-18T11:23:44.000Z",
    "updatedAt": "2025-01-23T08:20:33.211Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_9876e58e10c54577bee49d95b1f0268e~mv2.png/v1/fill/w_600,h_600,al_c,lg_1,q_85/7d6a1f_9876e58e10c54577bee49d95b1f0268e~mv2.png",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 4959
  },
  {
    "title": "Blue Card (Mavi Kart) Nasıl Alınır?",
    "slug": "/post/almanya-blue-card",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanya-blue-card-vize",
    "excerpt": "Almanya Blue Card vizesi hakkında bilmeniz gerekenler: Almanya'da oturum izni, Blue Card ile iş fırsatları ve aile birleşimi süreçleri. Almanya'da yüksek vasıflı göçmen olarak yeni bir hayat kurmanın yollarını blogumuzda keşfedin.",
    "description": "Almanya Blue Card vizesi hakkında bilmeniz gerekenler: Almanya'da oturum izni, Blue Card ile iş fırsatları ve aile birleşimi süreçleri. Almanya'da yüksek vasıflı göçmen olarak yeni bir hayat kurmanın yollarını blogumuzda keşfedin.",
    "date": "23 Nis 2021",
    "publishedAt": "2021-04-23T08:00:00.000Z",
    "updatedAt": "2025-01-23T08:20:08.407Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_327f0002fc5740dd93390a717e0cef6e~mv2.png/v1/fill/w_1000,h_668,al_c,q_90,usm_0.66_1.00_0.01/7d6a1f_327f0002fc5740dd93390a717e0cef6e~mv2.png",
    "readingTime": "6 dakikada okunur",
    "categories": [],
    "textLength": 8993
  },
  {
    "title": "Eyvah, Oğlum 3 Yaşına Giriyor!",
    "slug": "/post/eyvah-oglum-uc-yasina-giriyor",
    "canonicalUrl": "https://www.aysegulsarac.com/post/eyvah-oglum-uc-yasina-giriyor",
    "excerpt": "Henüz çocuğunun 3. yaşını görmeyen ana-babalar anlamaz beni a dostlar. Geçen sene ‘’ Bu 2 yaş sendromu da çekilir çile değilmiş,  bitsin de kurtulalım,’’ diyorduk. 3, 2’den beter çıktı. 🤦🏻‍♀️ Çocuk patronluğunu ilan etti. 👶🏻 Gel de itiraz et bu duruma, mümkün değiiiil. Baktık ki, bu patron modundan çıkacak gibi değil, ‘’Bir evde iki patron olmaz,’’ dedik ve ben istifamı verdim. Şimdi her şey, o ne diyorsa öyle oluyor. O keyifli, biz mutlu. 🙈 Size bir şey söyleyeyim mi? Ben, Jerfi Yiğit’in d",
    "description": "Henüz çocuğunun 3. yaşını görmeyen ana-babalar anlamaz beni a dostlar. Geçen sene ‘’ Bu 2 yaş sendromu da çekilir çile değilmiş,  bitsin de kurtulalım,’’ diyorduk. 3, 2’den beter çıktı. 🤦🏻‍♀️ Çocuk patronluğunu ilan etti. 👶🏻 Gel de itiraz et bu duruma, mümkün değiiiil. Baktık ki, bu patron modundan çıkacak gibi değil, ‘’Bir evde iki patron olmaz,’’ dedik ve ben istifamı verdim. Şimdi her şey, o ne diyorsa öyle oluyor. O keyifli, biz mutlu. 🙈 Size bir şey söyleyeyim mi? Ben, Jerfi Yiğit’in d",
    "date": "16 Nis 2021",
    "publishedAt": "2021-04-16T17:43:11.000Z",
    "updatedAt": "2025-01-23T08:19:37.650Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_4972190da3b642f3a272721434298be8~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/7d6a1f_4972190da3b642f3a272721434298be8~mv2.jpg",
    "readingTime": "5 dakikada okunur",
    "categories": [],
    "textLength": 7092
  },
  {
    "title": "İlham Perimin Geldiği Yere ve Zamana Bakın 🧚🏼‍♀️🤦🏻‍♀️",
    "slug": "/post/ilham-perisi",
    "canonicalUrl": "https://www.aysegulsarac.com/post/ilham-perisi",
    "excerpt": "Herkesin ilham perisinin sevdiği, olmaktan keyif aldığı, neşelendiği, neşelendirdiği muhteşem alanları vardır. Ama benim Peri’min zaman kavramı yok. Öyle bir yerde, öyle bir zamanda geliyor ki; ne yapacağımı şaşırıyorum, elim ayağıma dolanıyor.  Hatırlar mısınız? Kemal Sunal’ın bir filminde at yarışını tahmin edebilmesi için, ilhamının geldiği bir atmosfer yaratılıyordu hep. Allahtan benim Peri’m bu kadar seçici değil, nerede olsa geliyor ve hazırlıksız yakalıyor beni. 🧚🏼‍♀️ Kemal Sunal filmle",
    "description": "Herkesin ilham perisinin sevdiği, olmaktan keyif aldığı, neşelendiği, neşelendirdiği muhteşem alanları vardır. Ama benim Peri’min zaman kavramı yok. Öyle bir yerde, öyle bir zamanda geliyor ki; ne yapacağımı şaşırıyorum, elim ayağıma dolanıyor.  Hatırlar mısınız? Kemal Sunal’ın bir filminde at yarışını tahmin edebilmesi için, ilhamının geldiği bir atmosfer yaratılıyordu hep. Allahtan benim Peri’m bu kadar seçici değil, nerede olsa geliyor ve hazırlıksız yakalıyor beni. 🧚🏼‍♀️ Kemal Sunal filmle",
    "date": "11 Şub 2021",
    "publishedAt": "2021-02-11T06:00:00.000Z",
    "updatedAt": "2025-01-23T08:18:47.902Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_6d18dee204ed4f659f55f08be8d91282~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/7d6a1f_6d18dee204ed4f659f55f08be8d91282~mv2.jpg",
    "readingTime": "5 dakikada okunur",
    "categories": [],
    "textLength": 7022
  },
  {
    "title": "Bir Yıl Dönümü Hikayesi",
    "slug": "/post/yil-donumu-hikayesi",
    "canonicalUrl": "https://www.aysegulsarac.com/post/yil-donumu-hikayesi",
    "excerpt": "Merhaba, Bugün Köln’e gelişimizi üzerinden 1 yıl geçmiş. Ahhh ne çabuk. 🤷🏻‍♀️ Burada olduğumuz 1 yıl içinde doğanın her şeye iyi geldiğini, her durumdan keyif alabilmeyi, kendimize iyi bakabilmeyi ve bunu nasıl yapabileceğimizi öğrendik. 🤗 Bazen zamanın nasıl geçtiğini fark etmezsiniz ya hani, işte bu 1 yıl da öyle oldu benim için. Gerçi hayatım boyunca ‘’Bir türlü geçmedi şu zaman,’’ dediğim çok nadir olmuştur. Kötü hissettiğimiz zamanlar nasıl geçmek bilmiyorsa, iyi hissettiğimiz zamanlar d",
    "description": "Merhaba, Bugün Köln’e gelişimizi üzerinden 1 yıl geçmiş. Ahhh ne çabuk. 🤷🏻‍♀️ Burada olduğumuz 1 yıl içinde doğanın her şeye iyi geldiğini, her durumdan keyif alabilmeyi, kendimize iyi bakabilmeyi ve bunu nasıl yapabileceğimizi öğrendik. 🤗 Bazen zamanın nasıl geçtiğini fark etmezsiniz ya hani, işte bu 1 yıl da öyle oldu benim için. Gerçi hayatım boyunca ‘’Bir türlü geçmedi şu zaman,’’ dediğim çok nadir olmuştur. Kötü hissettiğimiz zamanlar nasıl geçmek bilmiyorsa, iyi hissettiğimiz zamanlar d",
    "date": "27 Oca 2021",
    "publishedAt": "2021-01-27T07:00:00.000Z",
    "updatedAt": "2025-01-23T08:17:17.752Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_43c22ffdae0b481fbba58f8471c1707a~mv2.jpg/v1/fill/w_537,h_1000,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_43c22ffdae0b481fbba58f8471c1707a~mv2.jpg",
    "readingTime": "5 dakikada okunur",
    "categories": [],
    "textLength": 7966
  },
  {
    "title": "Almanya'ya Gidiş Hazırlığı: Almanya'ya Göç Ediyoruz",
    "slug": "/post/almanyaya-gidis",
    "canonicalUrl": "https://www.aysegulsarac.com/post/almanyaya-gidis",
    "excerpt": "Almanya'ya göç etmek isteyenler için vize süreçleri, iş fırsatları, yaşam maliyetleri ve yerleşim hakkında bilmeniz gereken her şey. Almanya'da yeni bir hayat kurmanın yollarını öğrenin.",
    "description": "Almanya'ya göç etmek isteyenler için vize süreçleri, iş fırsatları, yaşam maliyetleri ve yerleşim hakkında bilmeniz gereken her şey. Almanya'da yeni bir hayat kurmanın yollarını öğrenin.",
    "date": "22 Oca 2021",
    "publishedAt": "2021-01-22T07:00:00.000Z",
    "updatedAt": "2025-01-23T08:16:53.697Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_196d06f7de1e41bfbb0f73a808ca16ad~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/7d6a1f_196d06f7de1e41bfbb0f73a808ca16ad~mv2.jpg",
    "readingTime": "11 dakikada okunur",
    "categories": [],
    "textLength": 15645
  },
  {
    "title": "Her İşte Bir Cevher Var",
    "slug": "/post/her-iste-bir-cevher-var",
    "canonicalUrl": "https://www.aysegulsarac.com/post/her-iste-bir-cevher-var",
    "excerpt": "Yıllar önce Ankara’dan İstanbul’a taşındığımızda, Kadıköy Tarihi Salı Pazarı’na gitmiştim. O kadar güzel kumaşlar, düğmeler, kurdeleler ve dikiş aksesuarları görmüştüm ki, ‘’Keşke terzi olsaydım,’’ diye geçirmiştim içimden.😇 Gördüğüm o güzel, rengarenk kumaşlar o kadar çok hayal kurdurmuştu ki bana; gömlekler, paltolar, ceketler dikebileceğime inanmıştım. 🙂 👗👕🧵 Daha önce hiç tecrübemiz olmayan konularda bile, harikalar yaratmışlık hissi verme gibi bir etkisi var hayallerin. Akşamına Mustafa",
    "description": "Yıllar önce Ankara’dan İstanbul’a taşındığımızda, Kadıköy Tarihi Salı Pazarı’na gitmiştim. O kadar güzel kumaşlar, düğmeler, kurdeleler ve dikiş aksesuarları görmüştüm ki, ‘’Keşke terzi olsaydım,’’ diye geçirmiştim içimden.😇 Gördüğüm o güzel, rengarenk kumaşlar o kadar çok hayal kurdurmuştu ki bana; gömlekler, paltolar, ceketler dikebileceğime inanmıştım. 🙂 👗👕🧵 Daha önce hiç tecrübemiz olmayan konularda bile, harikalar yaratmışlık hissi verme gibi bir etkisi var hayallerin. Akşamına Mustafa",
    "date": "12 Oca 2021",
    "publishedAt": "2021-01-12T10:22:14.000Z",
    "updatedAt": "2025-01-23T08:16:25.192Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/7d6a1f_ec156da4a7914ba8be4fab6d9ec594cb~mv2.jpg/v1/fill/w_1000,h_667,al_c,q_85,usm_0.66_1.00_0.01/7d6a1f_ec156da4a7914ba8be4fab6d9ec594cb~mv2.jpg",
    "readingTime": "3 dakikada okunur",
    "categories": [],
    "textLength": 4003
  },
  {
    "title": "Bu Blog İşi Nasıl Oldu?",
    "slug": "/post/bu-blog-isi-nasil-oldu",
    "canonicalUrl": "https://www.aysegulsarac.com/post/bu-blog-isi-nasil-oldu",
    "excerpt": "Almanya'ya göç sürecini adım adım keşfedin! Köln’e taşınırken yaşadıklarımızı, vize işlemlerinden ev kiralamaya, dil kurslarına kadar her detayı bu yazıda bulabilirsiniz. Hazırlıklarımızı ve blog açma sürecimizi nasıl gerçekleştirdiğimizi, kişisel tecrübelerimizi ve ilham verici hayallerimizi paylaşarak, göç eden aileler için pratik ipuçları sunuyoruz. Bizim gibi yeni bir başlangıç yapmak isteyenlere destek olacak bu yazıyla, hayallerin peşinden koşmaktan vazgeçmeyin!",
    "description": "Almanya'ya göç sürecini adım adım keşfedin! Köln’e taşınırken yaşadıklarımızı, vize işlemlerinden ev kiralamaya, dil kurslarına kadar her detayı bu yazıda bulabilirsiniz. Hazırlıklarımızı ve blog açma sürecimizi nasıl gerçekleştirdiğimizi, kişisel tecrübelerimizi ve ilham verici hayallerimizi paylaşarak, göç eden aileler için pratik ipuçları sunuyoruz. Bizim gibi yeni bir başlangıç yapmak isteyenlere destek olacak bu yazıyla, hayallerin peşinden koşmaktan vazgeçmeyin!",
    "date": "19 Ara 2020",
    "publishedAt": "2020-12-19T14:31:00.000Z",
    "updatedAt": "2025-01-23T08:15:06.198Z",
    "author": "Ayşegül Saraç",
    "image": "https://static.wixstatic.com/media/nsplsh_6b9e6874286944788a67e722562de02d~mv2.jpg/v1/fill/w_1000,h_665,al_c,q_85,usm_0.66_1.00_0.01/nsplsh_6b9e6874286944788a67e722562de02d~mv2.jpg",
    "readingTime": "2 dakikada okunur",
    "categories": [],
    "textLength": 2329
  }
];
